import MissingMoviesPage from 'pages/MissingMoviesPage/MissingMoviesPage'

export default MissingMoviesPage
